// What a technology card gives, for printing along the bottom of the card (as a wonder's permanent bonuses are): per
// worker for a card that is built on (farms, mines, urban buildings, units), once owned for a special technology, as
// the government for a government. Worked out once per card (and version, for one the expansion changed, e.g.
// Professional Sports) on a scratch civilization in a game of that version (the card with 1 worker against none, or
// owned against not), as that civilization's breakdowns credit it, and remembered.
//   CardBenefit(card) -> { perWorker: bool, bonuses: { culture: 2, happyFaces: 1, ... } } or null (not a technology)
const { CivilCardTypes } = require('../Constants/Names/CardTypes');
const TechnologyTypes = require('../Constants/TechnologyTypes');
const { VersionOf } = require('../Constants/CardVersions');

// Breakdown names, as the card bonuses call them
const Stats = { culture: 'culture', science: 'science', food: 'food', resources: 'resources', military: 'strength',
    happyFaces: 'happyFaces', colonization: 'colonization', civilActions: 'civilActions', militaryActions: 'militaryActions',
    blueTokens: 'blueTokens', yellowTokens: 'yellowTokens' };

const remembered = new Map();

// The scratch civilization's numbers credited to the card, with the card set up by setup(playerData), in a game whose
// changed cards are of this version
const credited = (name, setup, version) => {
    const GameState = require('../entities/GameState');
    const GameStateData = require('../dataEntities/GameStateData');
    const data = JSON.parse(JSON.stringify(new GameStateData([{ name: 'A' }, { name: 'B' }], { versions: version })));
    setup(data.playerStateData[0]);
    const breakdowns = new GameState(data).playerStates[0].GetBreakdowns();
    return Object.fromEntries(Object.entries(Stats).map(([key, stat]) =>
        [stat, (breakdowns[key] ?? []).filter(entry => entry.source === name).reduce((sum, entry) => sum + entry.value, 0)]));
};

const withWorkers = (name, workers) => (player) => {
    const existing = player.technologies.find(tech => tech.Type === name);
    if (existing) existing.contents = { ...existing.contents, workers };
    else player.technologies.push({ Type: name, contents: { workers } });
};

const CardBenefit = (card) => {
    const tech = card?.type === CivilCardTypes.Technology ? card.Technology : null;
    if (!tech)
    {
        return null;
    }
    const version = VersionOf(card);
    const key = `${tech.name}|${version}`;
    if (remembered.has(key))
    {
        return remembered.get(key);
    }
    let benefit;
    if (tech.type === TechnologyTypes.Government)
    {
        const owned = credited(tech.name, (player) => { player.government = tech.name; }, version);
        benefit = { perWorker: false, bonuses: nonZero(owned) };
    } else if (tech.workerCost === null || tech.workerCost === undefined) {
        const owned = credited(tech.name, (player) => player.technologies.push({ Type: tech.name, contents: {} }), version);
        benefit = { perWorker: false, bonuses: nonZero(owned) };
    } else {
        const one = credited(tech.name, withWorkers(tech.name, 1), version);
        const none = credited(tech.name, withWorkers(tech.name, 0), version);
        benefit = { perWorker: true, bonuses: nonZero(Object.fromEntries(Object.keys(one).map(stat => [stat, one[stat] - none[stat]]))) };
    }
    remembered.set(key, benefit);
    return benefit;
};

const nonZero = (values) => Object.fromEntries(Object.entries(values).filter(([, amount]) => amount !== 0));

module.exports = { CardBenefit };
